import { Text } from "@flat-ui";
import { UtilsTypes } from "@stellar/utils";
import { addProcessingProjects, removeProcessingProjects } from "@store/projects/projects-slice";
import { updateProjectDetails } from "@store/projects/projects-slice-thunk";
import { ProjectEvents } from "@utils/track-event/track-event-list";
/**
 * Shared logic to show archive/unarchive confirmation dialog and execute the action.
 * Used by both useProjectArchiveDialog hook and mobile menu.
 */
export async function showArchiveProjectDialog({
  project,
  createDialog,
  dispatch,
  trackEvent
}) {
  const isProjectActive = project.archivingState === "UNARCHIVED";

  // https://help.holobuilder.com/en/articles/3435523-how-to-archive-a-project-in-the-dashboard
  const whoCanViewArchived = [`${UtilsTypes.RoleDisplayNames.COMPANY_EXECUTIVE}s,`, `${UtilsTypes.RoleDisplayNames.COMPANY_MANAGER}s and`, `${UtilsTypes.RoleDisplayNames.PROJECT_MANAGER}s of this project`].join(" ");

  // Creates a modal dialog and waits for the user to perform an action
  const hasConfirmed = await createDialog({
    title: isProjectActive ? "Archive Project" : "Unarchive Project",
    confirmText: isProjectActive ? "Archive" : "Unarchive",
    isHideClose: true
  }, <>
      <Text variant="bodyL">
        Do you really want to {isProjectActive ? "archive" : "unarchive"} this
        project?
      </Text>
      <Text variant="bodyM" sx={{
      mt: "16px"
    }}>
        {isProjectActive ? `In archived state, only ${whoCanViewArchived} will be able to view the project online.` : "Afterwards, all project members will be able to access the project again."}
      </Text>
    </>);
  if (hasConfirmed) {
    trackEvent({
      name: isProjectActive ? ProjectEvents.archiveProject : ProjectEvents.unarchiveProject
    });

    // Add the projectId to processing projects to start the loading spinner in the project
    dispatch(addProcessingProjects([project.id]));
    const payload = {
      archivingState: isProjectActive ? "ARCHIVED" : "UNARCHIVED"
    };
    void dispatch(updateProjectDetails({
      projectId: project.id,
      payload
    }));

    // TODO: Maybe move adding/removing processing projects to the pending/fulfilled in project-slice
    // Remove projectId from processing project to stop the loading spinner in the project
    dispatch(removeProcessingProjects([project.id]));
    return true;
  }
  return false;
}